/* Adapted from shadcn/ui Dialog, MIT. Radix handles focus trapping and Escape. */
import * as React from 'react';
import { Dialog as Primitive } from 'radix-ui';
import { X } from 'lucide-react';
export const Dialog = Primitive.Root;
export const DialogTrigger = Primitive.Trigger;
export const DialogTitle = Primitive.Title;
export const DialogDescription = Primitive.Description;
export function DialogContent({ children, className='', showClose=true, ...props }: React.ComponentProps<typeof Primitive.Content> & {showClose?:boolean}) { return <Primitive.Portal><Primitive.Overlay className="dialog-overlay"/><Primitive.Content className={`dialog-content ${className}`} {...props}>{children}{showClose&&<Primitive.Close className="dialog-close" aria-label="Close dialog"><X size={20}/></Primitive.Close>}</Primitive.Content></Primitive.Portal>; }
